import { AccountData } from '../../components/account/accountData';
import { formatDate, localDayIndex } from '../../utils/dates';

export interface YourRow {
  key: string;
  competitionId: number;
  title: string;
  logo?: string | null;
  role: 'Joined' | 'Judging' | 'Hosting';
  line: string;
  action: 'Submit' | 'Open' | 'Evaluate' | 'Manage';
  to: string;
}

const MAX_ROWS = 6;
const HOST_ORDER = ['open', 'new', 'closed', 'archived'];
const low = (s?: string | null) => (s || '').toLowerCase();
/** Unknown statuses sort last. */
const hostRank = (s?: string | null) => { const i = HOST_ORDER.indexOf(low(s)); return i < 0 ? HOST_ORDER.length : i; };
const titleCase = (s?: string | null) => (s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : '');
const day = (d: string) => localDayIndex(d) ?? Number.MAX_SAFE_INTEGER;

export function yourCompetitions(data: AccountData, _now: Date = new Date()): YourRow[] {
  const joined = data.joined || [];
  const openJoined = joined.filter((c) => low(c.status) === 'open').sort((a, b) => day(a.end_date) - day(b.end_date))
    .map<YourRow>((c) => ({ key: `joined-${c.competition_id}`, competitionId: c.competition_id, title: c.title, logo: c.logo_path,
      role: 'Joined', line: `Closes ${formatDate(c.end_date)}`, action: 'Submit', to: `/competition/${c.competition_id}?tab=submit` }));
  const judging = (data.judging || []).filter((e) => low(e.status) === 'open' && e.max_votes > e.current_votes)
    .sort((a, b) => (b.max_votes - b.current_votes) - (a.max_votes - a.current_votes))
    .map<YourRow>((e) => {
      const left = e.max_votes - e.current_votes;
      return { key: `judging-${e.competition_id}`, competitionId: e.competition_id, title: e.title, logo: e.logo_path,
        role: 'Judging', line: `${left} evaluation${left === 1 ? '' : 's'} left`, action: 'Evaluate', to: `/evaluations/${e.competition_id}` };
    });
  const hosting = [...(data.hosting || [])]
    .sort((a, b) => hostRank(a.status) - hostRank(b.status))
    .map<YourRow>((h) => ({ key: `hosting-${h.id}`, competitionId: h.id, title: h.title, logo: h.logo_path,
      role: 'Hosting', line: titleCase(h.status), action: 'Manage', to: `/manage/${h.id}` }));
  const closedJoined = joined.filter((c) => low(c.status) !== 'open').sort((a, b) => day(b.end_date) - day(a.end_date))
    .map<YourRow>((c) => ({ key: `joined-${c.competition_id}`, competitionId: c.competition_id, title: c.title, logo: c.logo_path,
      role: 'Joined', line: low(c.status) === 'new' ? 'Opens soon' : 'Closed', action: 'Open', to: `/competition/${c.competition_id}` }));
  return [...openJoined, ...judging, ...hosting, ...closedJoined].slice(0, MAX_ROWS);
}
